import React, { useState } from "react";
import Star from "../../Stars/Star";
import "../FormA/FormA.css";
import { FaPlus } from "react-icons/fa";
import { MdDeleteOutline } from "react-icons/md";

const FormcomponentC = ({ placeholdtext, selectedStar, arrList }) => {
  const [rowcount, setRowcount] = useState(1);
  const handleSeleted = (incoming) => {
    selectedStar(incoming);
  };

  let tableHeader_cells = {
    colm_1:
      "What knowledge, skills and behaviours and/or specialist qualifications have been agreed for  development? These can relate to either the immediate requirements of the job or to career development objectives.",
    colm_2: "What action has been identified to support and develop these?",
    colm_3: "How/when will it be judged that they have been attained?",
  };

  const handleClick = () => {
    setRowcount(rowcount + 1);
  };

  const handleReduceClick = () => {
    if (rowcount > 1) {
      setRowcount(rowcount - 1);
    }
  };

  return (
    <div className="w-full">
      <table>
        <thead>
          <tr className="bg-[#C4BC96]">
            <th
              scope="col"
              className="text-center w-[40%] justify-center p-[0.425em] text-[13px] table_cell"
            >
              <b>
                What knowledge, skills and behaviours and/or specialist
                qualifications have been agreed for development? These can
                relate to either the immediate requirements of the job or to
                career development objectives.
              </b>{" "}
              <br />
            </th>

            <th
              scope="col"
              className="text-center w-[30%] min-w-[100px] justify-center p-[0.425em] text-[13px] table_cell"
            >
              <b>
                What action has been identified to support and develop these?
              </b>{" "}
              <br />
            </th>

            <th
              scope="col"
              className="text-center w-[30%] min-w-[100px] justify-center p-[0.425em] text-[13px] table_cell"
            >
              <b>How/when will it be judged that they have been attained?</b>{" "}
              <br />
            </th>
          </tr>
        </thead>

        <tbody>
          {[...Array(rowcount)].map((index) => {
            //   {jsonarray.kpis?.map((items, index) => {
            return (
              <tr>
                <td data-label={tableHeader_cells.colm_1}>
                  <input className="w-full py-2 outline-none" placeholder="Type skill" />
                </td>

                <td data-label={tableHeader_cells.colm_2}>
                  <input className="w-full py-2 outline-none" placeholder="Action taken"/>
                </td>

                <td data-label={tableHeader_cells.colm_3}>
                  <input className="w-full py-2 outline-none" placeholder="Timeline"/>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="flex gap-2 items-center my-2">
        <div
          onClick={handleClick}
          className="p-2 rounded-full flex items-center justify-center bg-[#1F3864] cursor-pointer"
        >
          <FaPlus size={13} color="#fff" />
        </div>

        <div
          onClick={handleReduceClick}
          className="p-2 rounded-full flex items-center justify-center bg-[#1F3864] cursor-pointer"
        >
          <MdDeleteOutline size={13} color="#fff" />
        </div>
      </div>

      <div className="flex flex-col w-full mt-4">
        <div className="comments_class pt-2 w-full flex justify-start">
          <div className="p-2 bg-[#E7E6E6] w-[150px]">
            Name of Manager/ Supervisor
          </div>
          <input className="w-full outline-none p-2 bg-[#fff]" />
        </div>

        <div className="comments_class w-full flex justify-between flex-wrap gap-2 items-center mt-2">
          <div className="flex grow min-w-[250px]">
            <div className="p-2 py-4 bg-[#E7E6E6] w-[150px]">Signature</div>
            <input className="w-full outline-none p-2 bg-[#fff]" />
          </div>

          <div className="flex grow min-w-[250px]">
            <div className="p-2 py-4 bg-[#E7E6E6] w-[150px]">Date</div>
            <input
              className="w-full outline-none p-2 bg-[#fff]"
              placeholder="dd/mm/yyyy"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormcomponentC;
